$(function() {
    focusActivetab();

    function focusActivetab() {
        var $activeTab = $('.collection-nav-tab.active');
        if ($activeTab.length) {
            var $container = $('.collection-nav-tabs');
            $container.animate({
            scrollLeft: $activeTab.offset().left - $container.offset().left + $container.scrollLeft()
            }, 400);
        }
    }
});